module.exports = __webpack_public_path__ + "static/img/banner-bg.cb5eb69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/spzx_xqy/banner-bg.png
// module id = Jlru
// module chunks = 1